import { IBaseDtoType } from './common.type'

export interface ILanguageBase {
  name: string
  code: string
  enabled: boolean
}

export interface ILanguageBaseWithId extends IBaseDtoType, ILanguageBase {}

export interface ILanguageForm {
  name: string
  code: string
  enabled: boolean
}

export interface ILanguagesRespDto {
  count: number
  data: Array<ILanguageBaseWithId>
}

export interface ICreateLanguageDto {
  name: string
  code: string
  enabled: boolean
}

export interface IUpdateLanguageDto extends ICreateLanguageDto {
  languageId: string
}

export interface ITranslationBase {
  namespace: string
  value: string | null
  ai_translation: string | null
  review_required: boolean
  type: ETranslationTypes
  helper_text: string | null
  helper_text_update: boolean
  ai_translation_helper: string | null
  language: ILanguageBase
}

export interface ITranslationBaseWithId extends IBaseDtoType, ITranslationBase {}

export interface ITranslationForm {
  value: string
  ai_translation: string
  namespace: string
  default_translation: string | null
  default_translation_helper: string | null
  review_required: boolean
  helper_text: string
  ai_translation_helper: string | null
}

export interface ITranslationWithDefault extends ITranslationBaseWithId {
  default: ITranslationBaseWithId | null
}

export interface ITranslationRespDto {
  count: number
  reviewRequiredCount: number
  missingTranslationsCount: number
  total: number
  data: Array<ITranslationWithDefault>
}

export interface IUpdateTranslationDto {
  translationId: string
  value: string
  ai_translation: string | null
  review_required: boolean
  helper_text: string
  ai_translation_helper: string | null
}

export interface IUpdateTranslationSwitchDto {
  translationId: string
  helper_text_update: boolean
}

export interface IGetTranslationHelperTextStatusDto {
  namespace: string
  ns_group: string | null
  languageCode: string
}

export interface ITranslationHelperStatusResDto {
  helper_text: string
  helper_text_update: boolean
}

export interface IUpdateMissingTranslationsDto {
  languageCode: string
  selectedItemsIds: string[]
}

export enum ETranslationTypes {
  Client = 'Client',
  Server = 'Server',
  Email = 'Email',
  Journey = 'Journey',
}

export enum ETranslationNs {
  Common = 'common',
  Accounts = 'accounts',
  Navbar = 'navbar',
  UserProfile = 'user-profile',
  Form = 'form',
  Validation = 'validation',
  Scans = 'scans',
  ScanForm = 'scan-form',
  Sort = 'sort',
  Filter = 'filter',
  TransactionLogs = 'transaction-logs',
  Users = 'users',
}
